export default (parameters) => {
  return {
    // "Weather Where You ___." — brand-neutral fallback
    sentence_activity: 'Are',
    // Feature 2 copy: "spots" for iKitesurf/iWindsurf, "locations" otherwise
    spot_noun: 'locations',
    // getCoverPhotos brand key ('ik' | 'iw'); null = no sheet fetch, use default_cover
    cover_photo_brand_key: null,
    // Brand display name used in the LIVE WIND feature copy
    live_wind_brand_name: '',
    // /brand/{brand} route value (parsed from the URL); pins a specific sheet row
    requested_cover_photo: null,
    // Dev-only ?feature= override; null = random 1-3 per load
    requested_feature_id: null,
    // Fallback cover photos (legacy CoverPhotosManager.GetBrandDefaults)
    default_cover: {
      top_photo: '',
      top_position: 'center',
      mid_photo: '',
      mid_position: 'center',
      brand_class: '',
      logo_color: 'white',
      tagline_color: 'white'
    },
    features: [],
    // Testimonial list override. When non-empty the store uses it instead of
    // fetching common/getTestimonials (which is currently server-to-server
    // only). Dev config supplies fixtures here.
    testimonials: []
  }
}
